import { connect } from 'react-redux'
import { appleHealthIntegration, endIntegration, syncIntegration } from '../../common/integration/integrationActions'
import { changeUserLanguage } from '../../common/language/languageActions'
import { IGlobalState } from '../../Root/store/appReducer'
import { Settings } from './Settings'
import {
  changePassword,
  deleteUser,
  getUserCompanyCountries,
  getCompanyDivisions,
  updateUser,
  joinCompany,
  setUserDivision,
  setUserCountry,
  leaveCompany,
  togglePublicStatus,
  deleteUserOwnedCompany,
} from './store/SettingsActions'
import {
  //userActivitySelector,
  companyCountriesSelector,
  companyDivisionsSelector,
  userDtoSelector,
  userCompaniesSelector,
} from './store/SettingsSelectors'
import { hasRole, hasRoleInCompany } from '../../common/auth/authSelectors'
import { CompanyId, Role } from '../../services/api.types'
import { getWhoAmI } from '../../common/auth/authActions'

const mapStateToProps = (state: IGlobalState) => ({
  hasRole: (role: Role) => hasRole(state, role),
  //activity: userActivitySelector(state),
  userDto: userDtoSelector(state),
  countries: companyCountriesSelector(state),
  divisions: companyDivisionsSelector(state),
  userCompanies: userCompaniesSelector(state),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
})

const mapDispatchToProps = {
  appleHealthIntegration,
  changePassword,
  changeUserLanguage,
  deleteUser,
  syncIntegration,
  updateUser,
  getUserCompanyCountries,
  getCompanyDivisions,
  joinCompany,
  leaveCompany,
  deleteUserOwnedCompany,
  setUserDivision,
  setUserCountry,
  endIntegration,
  togglePublicStatus,
  getWhoAmI,
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
